jQuery(function ($) {

    // Display prices for each membership type depending on country
    var $country = $('#country_id');
    var $type_prices = $('.member_type_price');
    var $reduced_price = $('.member_type_reduced_price');
    var prices = window.member_type_prices || false;

    function update_country() {
        var country_id = $country.val();

        // If no country is selected or the prices aren't loaded, show nothing
        if (!country_id || !prices) {
            $type_prices.text('');
            $reduced_price.text('');
            return;
        }

        // Work out which fee level applies to the selected country
        var fee_level_id = prices['country_to_fee_level'][country_id];

        // Display the price of each available membership type
        $type_prices.each(function () {
            var $placeholder = $(this);
            var member_type_id = $placeholder.data('member-type-id');
            var price = prices['fee_level_to_price'][fee_level_id][member_type_id];
            $placeholder.html(' &ndash; ' + price + ' per year');
        });

        // If a type has been selected, display the price for additional reduced price members (corporate form only)
        if ($reduced_price.length) {
            var selected_member_type_id = $('input[name=member_type_id]:checked').val();
            if (selected_member_type_id) {
                var price = prices['fee_level_to_reduced_member_fee'][fee_level_id][selected_member_type_id];
                $reduced_price.html(price + ' per year per member');
            } else {
                $reduced_price.html('');
            }
        }
    }

    if ($country.length) {
        $country.change(update_country);
        update_country();
    }
});
